import * as _ from 'lodash';
import { MissionStatus } from '../objects/Mission';
import { NoPartyOption } from '../objects/Party';
import { EntityCollection } from '../misc/EntityCollection';

function createCriteria(source) {
    let defaultCriteria = {
        Archived: 0,
    };

    return _.extend(defaultCriteria, _.cloneDeep(source));
}

angular.module("tromanWeb").controller('PersonsController', ['$q', 'stateService', 'tromanServer', 'ObjectCache', 'dialogService', 'systemInfo', 'personArchive', '$filter', function ($q, stateService, tromanServer, ObjectCache, dialogService, systemInfo, personArchive, $filter) {

    this.table = null;
    this.items = null;
    this.criteria = null;
    this.filter = null;
    this.loading = true;
    this.isPolitikerEnabled = systemInfo.IsPolitikerEnabled;

    function searchWithCriteria(criteria) {
        var sc = _.cloneDeep(criteria);
        delete sc.showIsDeceased;

        let noPartyIndex = _.indexOf(sc.PartyIds, NoPartyOption.Id);
        if (noPartyIndex >= 0) {
            sc.PartyIds.splice(noPartyIndex, 1);
            sc.WithoutParty = true;
        }

        return tromanServer.Persons.search(sc);
    }

    this.uiOnParamsChanged = function (changed) {
        if (_.has(changed, 'criteria')) {
            this.criteria = createCriteria(changed.criteria);
            this._refreshItems();
        }

        if (_.has(changed, 'filter')) {
            this.filter = changed.filter;
        }
    };

    this.$onInit = function () {
        const params = stateService.getParams();
        this.criteria = createCriteria(params.criteria);
        this.filter = params.filter;

        $q.all({
            organizations: ObjectCache.allOrganizations(),
            parties: ObjectCache.allParties(),
            organizationTypes: ObjectCache.getOrganizationTypes(),
            missionTypes: ObjectCache.getMissionTypes(),
            persons: searchWithCriteria(this.criteria),
        }).then(data => {
            this.organizationTypes = data.organizationTypes;
            this.missionTypes = data.missionTypes;
            this.organizations = new EntityCollection(data.organizations);
            this.parties = new EntityCollection([NoPartyOption].concat(data.parties));
            this.items = data.persons;
            this.error = null;
        }).catch(err => {
            this.error = err;
            this.items = null;
        }).finally(() => {
            this.loading = false;
        });
    };

    this._refreshItems = function _refreshItems(selectItems) {
        this.loading = true;
        searchWithCriteria(this.criteria).then(data => {
            this.error = null;
            this.items = data;
            if (selectItems) {
                var toselect = new Set(selectItems);
                this.items.forEach(person => {
                    person.$$selected = toselect.has(person.Id);
                });
            }
        }).catch(err => {
            this.error = err;
            this.items = null;
        }).finally(() => {
            this.loading = false;
        });
    };

    this.resetCriteria = function resetCriteria() {
        this.criteria = createCriteria(null);
    };

    this.search = function search() {
        stateService.reloadWithParams({ criteria: _.cloneDeep(this.criteria) });
    };

    this.filterChanged = function () {
        stateService.replaceParams({ filter: this.filter });
    };

    this.selectedOrganizationsChanged = function () {
        if (this.organizations.some(this.criteria.OrganizationIds, x => !x.Active)) {
            this.criteria.Archived = 1;
            this.criteria.OrganizationMissionStatus = MissionStatus.All;
        } else {
            this.criteria.OrganizationMissionStatus = null;
        }
    };

    this.selectedPartiesChanged = function () {
        if (this.parties.some(this.criteria.PartyIds, x => !x.Active)) {
            this.criteria.Archived = 1;
        }
    };

    this.createList = function createList() {
        if (this.table == null) return;
        var list = this.table.selectedItems();
        dialogService.createPersonList(list);
    };

    this.emailList = function emailList() {
        if (this.table == null) return;
        var list = this.table.selectedItems();
        dialogService.createEmailList(list);
    };

    this.createReport = function createReport() {
        if (this.table == null) return;
        var list = this.table.selectedItems();
        dialogService.createReport({ persons: list });
    };

    function formatResponse(res, options) {
        var ret = [];

        if (res.Archived === 1) {
            ret.push("1 person arkiverad.");
        } else {
            ret.push(res.Archived + " personer arkiverade.");
        }

        if (res.WithLoanedEquipment >= 1) {
            if (res.Archived === 1) {
                ret.push({ text: "Personen har ej återlämnad utrustning.", iserror: true });
            } else {
                ret.push({ text: res.WithLoanedEquipment + " av personerna har ej återlämnad utrustning.", iserror: true });
            }
        }

        if (res.AlreadyArchived === 1) {
            ret.push("1 person var redan arkiverad.");
        } else if (res.AlreadyArchived > 1) {
            ret.push(res.AlreadyArchived + " personer var redan arkiverade.");
        }

        if (res.NotArchived != null) {
            if (res.NotArchived.length === 1) {
                ret.push("1 person kunde inte arkiveras. Den har markerats i personlistan.");
            } else if (res.NotArchived.length > 1) {
                ret.push(res.NotArchived.length + " personer kunde inte arkiveras. De har markerats i personlistan.");
            }
        }

        if (options.clearContact) {
            if (res.Cleared === 1) {
                ret.push("1 person hade kontaktuppgifter som raderades.");
            } else {
                ret.push(res.Cleared + " personer hade kontaktuppgifter som raderades.");
            }
        }

        if (options.deleteFiles) {
            if (res.WithDeletedFiles === 1) {
                ret.push("1 person hade dokument/foto som raderades.");
            } else {
                ret.push(res.Cleared + " personer hade dokument/foto som raderades.");
            }
        }

        if (options.unpublish) {
            if (res.Unpublished === 1) {
                ret.push("1 person har avpublicerats från Troman Publik.");
            } else {
                ret.push(res.Unpublished + " personer har avpublicerats från Troman Publik.");
            }
        }

        if (options.politikerExpireDate != null) {
            if (res.PolitikerExpireSet === 0) {
                ret.push("0 personer har fått tillgång till Troman Politiker avslutad.");
            } else if (res.PolitikerExpireSet === 1) {
                ret.push(`1 persons tillgång till Troman Politiker avslutas ${$filter('ergoDate')(options.politikerExpireDate)}.`);
            } else {
                ret.push(`${res.PolitikerExpireSet} personers tillgång till Troman Politiker avslutas ${$filter('ergoDate')(options.politikerExpireDate)}.`);
            }
        }

        return ret;
    }

    this.archiveSelection = function archiveSelection() {
        if (this.table == null) return;
        var selected = this.table.selectedItems();

        personArchive.archiveMultiple(selected).then(opt => {
            tromanServer.Persons.archiveMultiple(selected, opt.clearContact, opt.unpublish, opt.politikerExpireDate, opt.deleteFiles)
                .then(res => {
                    dialogService.notify(formatResponse(res, opt), "Arkivera personer").then(() => {
                        this._refreshItems(res.NotArchived);
                    });
                })
                .catch(dialogService.error);
        });
    };
}]);
